<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
        <h2 class="headline m-0 flex-auto">{{data.title}}</h2>
        <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
            <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
    </div>
    <mat-divider class="text-border"></mat-divider>
    <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col gap-4 mb-2">
            <mat-label>Envio a</mat-label>
            <mat-radio-group class="flex gap-4">
                <mat-radio-button [checked]="true" value="1" (change)="radioChange($event)">Grupo</mat-radio-button>
                <mat-radio-button value="2" (change)="radioChange($event)">Socio</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-form-field class="flex-auto">
            <mat-label>Tipo envio</mat-label>
            <mat-select formControlName="tipoEnvio" [(ngModel)]="selectedOption" (selectionChange)="onChangeTipoEnvio($event.value)">
                <mat-option *ngFor="let item of tiposEnvio" [value]="item"> {{item}} </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="flex flex-col sm:flex-row sm:gap-4" *ngIf="showDespuesEnvio">
            <mat-form-field>
                <mat-label>Fecha envio</mat-label>
                <input formControlName="fechaEnvio" (click)="formDatepickerRef.open()"
                    (focus)="formDatepickerRef.open()" [matDatepicker]="formDatepickerRef" matInput readonly>
                <mat-datepicker-toggle [for]="formDatepickerRef" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #formDatepickerRef></mat-datepicker>
            </mat-form-field>
            <!--<mat-form-field class="flex-auto">
                <mat-label>Hora envio</mat-label>
                <mat-select formControlName="horaEnvio">
                    <mat-option *ngFor="let item of hours" [value]="item">
                        {{shours[item]}} </mat-option>
                </mat-select>
            </mat-form-field>-->
            
            <mat-form-field class="flex-auto">
                <mat-label>Hora envio</mat-label>
                <input formControlName="despues" type="time" matInput>
            </mat-form-field> 
<!-- 
            <mat-form-field>
                <input type="text" matInput [matTimepicker]="timepicker" />
                <mat-timepicker-toggle matSuffix [for]="timepicker"></mat-timepicker-toggle>
                <mat-timepicker #timepicker></mat-timepicker>
            </mat-form-field>-->
              

        </div>
        <mat-form-field class="flex-auto">
            <mat-label>Titulo</mat-label>
            <input formControlName="titulo" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Mensaje</mat-label>
            <input formControlName="cuerpo" matInput>
        </mat-form-field>
        <mat-form-field class="flex-auto" *ngIf="isGroup">
            <mat-label>Grupo</mat-label>
            <mat-select formControlName="idGrupo">
                <mat-option *ngFor="let item of grupos" [value]="item.id">
                    {{item.nombre}} </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto" *ngIf="!isGroup">
            <mat-label>Socio</mat-label>
            <mat-select formControlName="idSocio">
                <mat-option *ngFor="let item of socios" [value]="item.id">
                    {{item.razonSocial}} </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto">
            <mat-label>Tipo notificación</mat-label>
            <mat-select formControlName="tipoNotificacion" multiple>
                <mat-option *ngFor="let item of tiposNotificacion" [value]="item">
                    {{item}} </mat-option>
            </mat-select>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>
        <!-- <button [disabled]="form.invalid" color="primary" mat-flat-button type="submit">{{data.button}}</button> -->
        <button color="primary" mat-flat-button type="submit">{{data.button}}</button>
    </mat-dialog-actions>
</form>